import { Component } from '@angular/core';

@Component({
  selector: 'app-catalogue-clinic-supplies',
  templateUrl: './catalogue-clinic-supplies.component.html',
  styleUrls: ['./catalogue-clinic-supplies.component.less'],
})
export class CatalogueClinicSuppliesComponent {
  disableGrid = false;

  constructor() {}

  changeDisableGrid($event: boolean) {
    this.disableGrid = $event;
  }
}
